import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// New global foundation + shared shell
import './styles/globals.css';
import LandingPage from './pages/landing/LandingPage';
import Footer from './components/Footer';
import ContactModal from './ContactSheet';
import Lastpaper from './pages/LastPaper';
import Manifesto from './pages/Manifesto';
import Download from './pages/Download';

// Routed pages (unchanged)
import FAQ from './pages/FAQ';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import Rewards from './pages/Rewards';
import SweepstakesRules from './pages/SweepstakesRules';
import AccountDeletion from './pages/AccountDeletion';
import Contact from './pages/Contact';
import PageMetadata from './components/PageMetadata';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [contactIntent, setContactIntent] = useState('');
  const handleOpenModal = () => { setContactIntent(''); setIsModalOpen(true); };
  const handleDeletion = () => { setContactIntent('Account & Data Deletion'); setIsModalOpen(true); };

  return (
    <Router>
      <ScrollToTop />
      <PageMetadata />
      <Routes>
        <Route path="/" element={<LandingPage onContactClick={handleOpenModal} />} />
        <Route path="/faq" element={<FAQ onContactClick={handleOpenModal} />} />
        <Route path="/manifesto" element={<Manifesto />} />
        <Route path="/Lastpaper" element={<Lastpaper />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/account-deletion" element={<AccountDeletion onRequestDeletion={handleDeletion} />} />
        <Route path="/contact" element={<Contact onContactClick={handleOpenModal} />} />
        <Route path="/rewards" element={<Rewards />} />
        <Route path="/sweepstakes-rules" element={<SweepstakesRules />} />
        <Route path="/download" element={<Download />} />
      </Routes>

      {/* Site-wide footer: one instance covers every route */}
      <Footer onContactClick={handleOpenModal} />

      {/* Modal at root so it can open from any page */}
      <ContactModal initialSubject={contactIntent} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </Router>
  );
}

export default App;
